import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CompanyResponse, CompanyServiceResponse } from '../../../../@shared/models/response.module';
import { EndpointService } from '../../../../@shared/endpoints.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AddService } from './components/add-service/add-service';
import { DeleteModal } from '../../../../@shared/components/delete-modal/delete-modal';
import { ToastService } from '../../../../@core/services/toast.service';

@Component({
  selector: 'app-company-profile-services',
  standalone: false,
  templateUrl: './company-profile-services.html',
  styleUrl: './company-profile-services.css'
})
export class CompanyProfileServices implements OnChanges {
  @Input() company: CompanyResponse;

  services: CompanyServiceResponse[] = [];
  loading: boolean = false;

  constructor(
    private endpointService: EndpointService,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private toastService: ToastService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['company'] && this.company?.company_id) {
      this.getServices();
    }
  }

  getServices() {
    if (!this.company?.company_id) {
      return;
    }
    this.loading = true;
    this.endpointService.csr_1(this.company.company_id).subscribe({
      next: (res) => {
        this.services = res.data || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.services = [];
      }
    });
  }

  openAddModal() {
    const modalRef = this.modalService.open(AddService, { size: 'lg', centered: true });
    modalRef.componentInstance.company = this.company;
    modalRef.result.then((result) => {
      if (result) {
        this.getServices();
      }
    }).catch(() => {});
  }

  openEditModal(service: CompanyServiceResponse) {
    const modalRef = this.modalService.open(AddService, { size: 'lg', centered: true });
    modalRef.componentInstance.company = this.company;
    modalRef.componentInstance.editMode = true;
    modalRef.componentInstance.service = service;
    modalRef.result.then((result) => {
      if (result) {
        this.getServices();
      }
    }).catch(() => {});
  }

  toggleServiceStatus(service: CompanyServiceResponse) {
    const newStatus = service.is_active ? 0 : 1;
    this.endpointService.csr_3(service.service_id, { is_active: newStatus }).subscribe({
      next: () => {
        this.toastService.success(this.translateService.instant('companyProfile.services.statusUpdated'));
        this.getServices();
      },
      error: (err) => {
        console.error('Error updating service status:', err);
        this.toastService.error(this.translateService.instant('companyProfile.services.statusError'));
      }
    });
  }

  deleteService(service: CompanyServiceResponse) {
    const modalRef = this.modalService.open(DeleteModal, { centered: true });
    modalRef.componentInstance.description = this.translateService.instant('companyProfile.services.deleteConfirm');
    modalRef.result.then((result) => {
      if (result) {
        this.endpointService.csr_4(service.service_id).subscribe({
          next: () => {
            this.toastService.success(this.translateService.instant('companyProfile.services.deleteSuccess'));
            this.getServices();
          },
          error: (err) => {
            console.error('Error deleting service:', err);
            this.toastService.error(this.translateService.instant('companyProfile.services.deleteError'));
          }
        });
      }
    }).catch(() => {});
  }

  formatPrice(priceCents: number): string {
    return (priceCents / 100).toFixed(2);
  }

  getVatLabel(vatRate: number): string {
    if (vatRate === 0) return 'No VAT';
    return `${vatRate}% VAT`;
  }
}
